import { animate, inView } from "motion";

document.addEventListener('DOMContentLoaded', () => {
    const componentVideos = document.querySelectorAll('.component-video');

    if (componentVideos.length === 0) return;

    componentVideos.forEach(component => {
        const video = component.querySelector('video');
        const cover = component.querySelector('.component-video__cover');

        inView(component, () => {
            const sources = video.querySelectorAll('source');

            sources.forEach(source => {
                if (source.hasAttribute('data-mobiles-video-src')) {
                    source.src = source.dataset.mobilesVideoSrc;
                } else if (source.hasAttribute('data-desktop-video-src')) {
                    source.src = source.dataset.desktopVideoSrc;
                }
            });

            video.load();

            // Hide cover with a fade and timeout fallback
            if (cover) {
                animate(cover, { opacity: 0 }, { duration: 3, delay: 1.2 });
            }

            video.classList.remove('hidden'); // 👈 Removes Tailwind's display: none

            video.play().catch(e => {
                console.error('Video play failed', e);
            });
        }, {
            amount: 0.2
        });
    });
});